export enum TipoCertificado {
    Invalid = 0,
    Ganancias,
    IIBBObraSocialMunicipal
}